module.exports = __webpack_public_path__ + "img/Module-Page-Top-Wireframes-Responsive.2a84f69f.svg";